<template>
  <div class="big-plot" style="height: 750px; text-align: center">
    <div style="
        display: inline-flex;
        background: #f5f7fa;
        border-radius: 14px;
        margin-bottom: 20px;
      ">
      <div @click="adj_or_not = 'adj'" :class="[
        'calMethod',
        adj_or_not == 'adj'
          ? `calMethod-active-${calMethod}`
          : 'calMethod-deactive',
      ]">
        <div class="tag-title">ClinSRs after collective adjustment</div>
      </div>
      <div @click="adj_or_not = 'not'" :class="[
        'calMethod',
        adj_or_not == 'not'
          ? `calMethod-active-${calMethod}`
          : 'calMethod-deactive',
      ]">
        <div class="tag-title">ClinSRs before collective adjustment</div>
      </div>
    </div>

    <div v-if="'time_window' in this.graph" style="height: 700px">
      <BaseECharts :option="chartOption" />
    </div>
  </div>
</template>

<script>
import BaseECharts from "@/components/BaseECharts.vue";
export default {
  data() {
    return {
      adj_or_not: "adj",

    };
  },
  props: {
    plotRateTrendData: {
      type: Object,
      required: true,
    },
    calMethod: {
      type: String,
      required: true,
    },
  },

  components: {
    BaseECharts,
  },
  methods: {
    // generatePatternDataURL(color) {
    //   // 使用模板字符串替换stroke属性中的颜色值
    //   var svgPatternString = `
    //     <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
    //         <line x1="0" y1="2" x2="10" y2="2" stroke="${color}"/>
    //         <line x1="0" y1="5" x2="10" y2="5" stroke="${color}"/>
    //         <line x1="0" y1="8" x2="10" y2="8" stroke="${color}"/>
    //     </svg>`;
    //   // 将SVG字符串转换为Base64编码的数据URL
    //   var patternDataURL =
    //     "data:image/svg+xml;base64," +
    //     btoa(unescape(encodeURIComponent(svgPatternString)));
    //   return patternDataURL;
    // },
  },

  computed: {
    bgColors() {
      switch (this.calMethod) {
        case "CDPs":
          return ["rgb(252, 250, 226)", "rgb(255, 255, 255)"];
        case "MEs":
          return ["rgb(215, 231, 243)", "rgb(255, 255, 255)"];
        case "Industry":
          return ["rgb(216, 238, 208)", "rgb(255, 255, 255)"];
        default:
          return ["rgb(255, 255, 255)", "rgb(255, 255, 255)"]; // 默认值
      }
    },
    graph() {
      return this.plotRateTrendData;
    },
    chartOption() {
      if (this.adj_or_not != "adj") {
        return this.chartOptionNoAdj;
      } else {
        return this.chartOptionAdj;
      }
    },
    chartOptionAdj() {
      if (!("time_window" in this.graph)) {
        return {};
      }

      const option = {
        textStyle: {
          fontFamily: "Harding",
        },
        legend: [
          {
            data: [
              `P1SR after collective adjustment`,
              `P2SR after collective adjustment`,
              `P3SR after collective adjustment`,
              `OSR after collective adjustment`,
            ],
            itemGap: 20,
            textStyle: {
              fontSize: "14",
            },
          },
        ],
        grid: {
          top: "2%",
          left: "3%",
          right: "3%",
          bottom: "6%",
          containLabel: true,
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            saveAsImage: {},
          },
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.graph.time_window,
            axisTick: {
              alignWithLabel: false,
              show: true,
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                color: "#000",
              },
            },
            axisLabel: {
              interval: 0,
              rotate: 40,
              textStyle: {
                color: "#000",
                fontSize: "18px",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            name: "Phase Success Rate (PSR)",
            max: 100,
            nameLocation: "center",
            nameGap: 55,
            nameTextStyle: {
              color: "#000",
              fontSize: "18px",
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                color: "#000",
              },
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              formatter: (params) => {
                return `${params}%`;
              },
              color: "#000",
              textStyle: {
                fontSize: "18px",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            name: "Overall Success Rate (OSR)",
            max: 70,
            nameRotate: -90,
            nameLocation: "middle",
            nameGap: 55,
            nameTextStyle: {
              color: "#000",
              fontSize: "18px",
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                color: "#000",
              },
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              formatter: (params) => {
                return `${params}%`;
              },
              color: "#000",
              textStyle: {
                fontSize: "18px",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            min: 0,
            max: 1,
            axisPointer: {
              type: "none",
            },
            show: false,
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          enterable: true,
          confine: true,
          formatter: function (params) {
            // console.log(params)
            var htmlStr = "";
            for (var i = 0; i < params.length - 1; i++) {
              var param = params[i];
              var xName = param.name;
              var seriesName = param.seriesName;
              var value = param.value;
              var color =
                param.color instanceof Object
                  ? param.color.colorStops[0].color
                  : param.color;
              if (i === 0) {
                htmlStr +=
                  '<div style="font-size:14px;color:#666;font-weight:400;line-height:1;">' +
                  xName +
                  "</div>";
              }
              htmlStr +=
                '<div style="margin: 6px 0 0;line-height:1;display: flex;">' +
                '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' +
                color +
                ';"></span>' +
                '<span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">' +
                seriesName +
                "</span>" +
                '<span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">' +
                (parseFloat(value) + 0.002).toFixed(1) +
                "%" +
                "</span>" +
                "</div>";
            }
            return htmlStr;
          },
        },
        series: [
          {
            name: `P1SR after collective adjustment`,
            z: 2,
            type: "bar",
            data: this.graph.P1SR_adjustment,
            itemStyle: {
              color: {
                type: "linear",
                x: 1,
                x2: 0,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgb(101, 162, 210)" },
                  { offset: 0.3, color: "rgb(101, 162, 210)" },
                  { offset: 0.5, color: "rgb(162, 185, 226)" },
                  { offset: 0.75, color: "rgb(101, 162, 210)" },
                  { offset: 1, color: "rgb(101, 162, 210)" },
                ],
              },
            },
          },
          {
            name: `P2SR after collective adjustment`,
            z: 2,
            type: "bar",
            data: this.graph.P2SR_adjustment,
            itemStyle: {
              color: {
                type: "linear",
                x: 1,
                x2: 0,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgb(235, 202, 83)" },
                  { offset: 0.3, color: "rgb(235, 202, 83)" },
                  { offset: 0.5, color: "rgb(255, 231, 163)" },
                  { offset: 0.75, color: "rgb(235, 202, 83)" },
                  { offset: 1, color: "rgb(235, 202, 83)" },
                ],
              },
            },
          },
          {
            name: `P3SR after collective adjustment`,
            z: 2,
            type: "bar",
            data: this.graph.P3SR_adjustment,
            itemStyle: {
              color: {
                type: "linear",
                x: 1,
                x2: 0,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgb(231, 111, 108)" },
                  { offset: 0.3, color: "rgb(231, 111, 108)" },
                  { offset: 0.5, color: "rgb(240, 166, 162)" },
                  { offset: 0.75, color: "rgb(231, 111, 108)" },
                  { offset: 1, color: "rgb(231, 111, 108)" },
                ],
              },
            },
          },
          {
            name: `OSR after collective adjustment`,
            z: 3,
            type: "line",
            data: this.graph.OSR_adjustment,
            yAxisIndex: 1,
            symbol: "diamond",
            symbolSize: 13,
            animationDelay: 1000,
            animationEasing: "linear",
            animationDuration: 4000,
            itemStyle: {
              normal: {
                color: "rgb(153, 0, 204)",
                lineStyle: {
                  color: "rgb(153, 0, 204)",
                  width: 3,
                  type: "dashed",
                },
              },
            },
          },

          {
            name: "use4bg",
            z: 1,
            type: "line",
            data: this.graph.OSR_adjustment.map(() => 1),
            yAxisIndex: 2,
            xAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "rgba(0, 0, 0,0)",
                lineStyle: {
                  color: "rgba(0, 0, 0,0)",
                },
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 1,
                x2: 0,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: this.bgColors[0] },
                  { offset: 1, color: this.bgColors[1] },
                ],
              },
            },
          },
        ],
      };

      // 添加额外的xAxis和yAxis
      option.xAxis[1] = {
        type: "category",
        boundaryGap: false,
        axisPointer: {
          type: "none",
        },
        show: false,
      };

      return option;
    },

    chartOptionNoAdj() {
      if (!("time_window" in this.graph)) {
        return {};
      }

      const option = {
        textStyle: {
          fontFamily: "Harding",
        },
        legend: [
          {
            data: [
              `P1SR before collective adjustment`,
              `P2SR before collective adjustment`,
              `P3SR before collective adjustment`,
              `OSR before collective adjustment`,
            ],
            itemGap: 20,
            textStyle: {
              fontSize: "14",
            },
          },
        ],
        grid: {
          top: "2%",
          left: "3%",
          right: "3%",
          bottom: "6%",
          containLabel: true,
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            saveAsImage: {},
          },
        },
        
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.graph.time_window,
            axisTick: {
              alignWithLabel: false,
              show: true,
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                color: "#000",
              },
            },
            axisLabel: {
              interval: 0,
              rotate: 40,
              textStyle: {
                color: "#000",
                fontSize: "18px",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            name: "Phase Success Rate (PSR)",
            max: 100,
            nameLocation: "center",
            nameGap: 55,
            nameTextStyle: {
              color: "#000",
              fontSize: "18px",
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                color: "#000",
              },
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              formatter: (params) => {
                return `${params}%`;
              },
              color: "#000",
              textStyle: {
                fontSize: "18px",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            name: "Overall Success Rate (OSR)",
            max: 70,
            nameRotate: -90,
            nameLocation: "middle",
            nameGap: 55,
            nameTextStyle: {
              color: "#000",
              fontSize: "18px",
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                color: "#000",
              },
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              formatter: (params) => {
                return `${params}%`;
              },
              color: "#000",
              textStyle: {
                fontSize: "18px",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            min: 0,
            max: 1,
            axisPointer: {
              type: "none",
            },
            show: false,
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          enterable: true,
          confine: true,
          formatter: function (params) {
            var htmlStr = "";
            for (var i = 0; i < params.length - 1; i++) {
              var param = params[i];
              var xName = param.name;
              var seriesName = param.seriesName;
              var value = param.value;
              var color =
                param.color instanceof Object
                  ? param.color.colorStops[0].color
                  : param.color;
              if (i === 0) {
                htmlStr +=
                  '<div style="font-size:14px;color:#666;font-weight:400;line-height:1;">' +
                  xName +
                  "</div>";
              }
              htmlStr +=
                '<div style="margin: 6px 0 0;line-height:1;display: flex;">' +
                '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' +
                color +
                ';"></span>' +
                '<span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">' +
                seriesName +
                "</span>" +
                '<span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">' +
                (parseFloat(value) + 0.002).toFixed(1) +
                "%" +
                "</span>" +
                "</div>";
            }
            return htmlStr;
          },
        },
        series: [
          {
            name: `P1SR before collective adjustment`,
            z: 2,
            type: "bar",
            data: this.graph.P1SR,
            itemStyle: {
              color: {
                type: "linear",
                x: 1,
                x2: 0,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgb(101, 162, 210)" },
                  { offset: 0.3, color: "rgb(101, 162, 210)" },
                  { offset: 0.5, color: "rgb(162, 185, 226)" },
                  { offset: 0.75, color: "rgb(101, 162, 210)" },
                  { offset: 1, color: "rgb(101, 162, 210)" },
                ],
              },
            },
          },
          {
            name: `P2SR before collective adjustment`,
            z: 2,
            type: "bar",
            data: this.graph.P2SR,
            itemStyle: {
              color: {
                type: "linear",
                x: 1,
                x2: 0,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgb(235, 202, 83)" },
                  { offset: 0.3, color: "rgb(235, 202, 83)" },
                  { offset: 0.5, color: "rgb(255, 231, 163)" },
                  { offset: 0.75, color: "rgb(235, 202, 83)" },
                  { offset: 1, color: "rgb(235, 202, 83)" },
                ],
              },
            },
          },
          {
            name: `P3SR before collective adjustment`,
            z: 2,
            type: "bar",
            data: this.graph.P3SR,
            itemStyle: {
              color: {
                type: "linear",
                x: 1,
                x2: 0,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "rgb(231, 111, 108)" },
                  { offset: 0.3, color: "rgb(231, 111, 108)" },
                  { offset: 0.5, color: "rgb(240, 166, 162)" },
                  { offset: 0.75, color: "rgb(231, 111, 108)" },
                  { offset: 1, color: "rgb(231, 111, 108)" },
                ],
              },
            },
          },
          {
            name: `OSR before collective adjustment`,
            z: 3,
            type: "line",
            data: this.graph.OSR,
            yAxisIndex: 1,
            symbol: "circle",
            symbolSize: 10,
            animationDelay: 1000,
            animationEasing: "linear",
            animationDuration: 4000,
            itemStyle: {
              normal: {
                color: "rgb(0, 0, 0)",
                lineStyle: {
                  color: "rgb(0, 0, 0)",
                  width: 3,
                },
              },
            },
          },

          {
            name: "use4bg",
            z: 1,
            type: "line",
            data: this.graph.OSR.map(() => 1),
            yAxisIndex: 2,
            xAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "rgba(0, 0, 0,0)",
                lineStyle: {
                  color: "rgba(0, 0, 0,0)",
                },
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 1,
                x2: 0,
                y: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: this.bgColors[0] },
                  { offset: 1, color: this.bgColors[1] },
                ],
              },
            },
          },
        ],
      };

      // 添加额外的xAxis和yAxis
      option.xAxis[1] = {
        type: "category",
        boundaryGap: false,
        axisPointer: {
          type: "none",
        },
        show: false,
      };

      return option;
    },
  },
};
</script>


<style scoped></style>